<template>
  <div class="invoice">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>Exhibiting</BreadcrumbItem>
          <BreadcrumbItem>Invoice</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibitionEn/index/exinfo/invoice-alter');">
          <span>Back</span>
        </div>
      </div>
    </div>

    <div class="invoice-content">
      <Form
        ref="formInline2"
        :model="formInline2"
        :rules="ruleInline2"
        label-position="right"
        :label-width="225"
        @submit.native.prevent
      >
        <p style="padding-left: 225px;color: #ff0000;line-height: 34px;">Please ensure the invoice information filled is correct (VAT Invoice Only)</p>
        <FormItem label="Invoice title：" prop="Title">
          <Input type="text" style="width:600px;" v-model="formInline2.Title" placeholder="Please enter the company name on the business license" />
        </FormItem>
        <FormItem label="Tax registration number：" prop="Code">
          <Input type="text" style="width:600px;" v-model="formInline2.Code" placeholder="Please enter 15-20 valid Taxpayer Identification Number" />
          <p
            style="font-size: 14px;color: #808080;line-height: initial;padding-top:5px;"
          >Please enter the accurate Social Unified Credit Code or Taxpayer Identification Number carefully after checking with finance personnel</p>
        </FormItem>
        <FormItem label="Bank name：" prop="BankName">
          <Input type="text" style="width:600px;" v-model="formInline2.BankName" placeholder="Please enter the bank name on your account opening license" />
        </FormItem>
        <FormItem label="Account number：" prop="BankNumber">
          <Input type="text" style="width:600px;" v-model="formInline2.BankNumber" placeholder="Please enter the account number on your account opening license" />
        </FormItem>
        <FormItem label="Registered address：" prop="Address">
          <Input type="text" style="width:600px;" v-model="formInline2.Address" placeholder="Please enter the registered address on your business license" />
        </FormItem>
        <FormItem label="Registered telephone number：" prop="Tel">
          <Input type="text" style="width:600px;" v-model="formInline2.Tel" placeholder="Please enter a valid contact number of your company" />
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            size="large"
            :loading="loading"
            @click="handleSubmit('formInline2')"
            style="width: 154px;"
          >Save</Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "exhibition-info-invoice",
  data() {
    return {
      invoiceDownInfo: null,
      loading: false,

      formInline2: {
        // form双向绑定
        Title: "", // 发票抬头
        Code: "", // 税务登记证号(纳税人识别号)
        BankName: "", // 开户银行名称
        BankNumber: "", // 开户银行账号
        Address: "", // 注册场所地址
        Tel: "" // 注册固定电话
      },
      ruleInline2: {
        // 效验规则
        Title: [{ required: true, message: "Invoice title", trigger: "blur" }],
        Code: [
          {
            required: true,
            message: "Tax registration number could not be empty",
            trigger: "blur"
          },
          {
            type: "string",
            min: 15,
            message: "Tax registration certificate number less than 15 digits",
            trigger: "blur"
          },
          {
            type: "string",
            max: 20,
            message: "Tax registration certificate number more than 20 digits",
            trigger: "blur"
          }
        ],
        BankName: [
          { required: true, message: "Bank name could not be empty", trigger: "blur" }
        ],
        BankNumber: [
          { required: true, message: "Account number could not be empty", trigger: "blur" }
        ],
        Address: [
          { required: true, message: "Registered address could not be empty", trigger: "blur" }
        ],
        Tel: [{ required: true, message: "Registered telephone number could not be empty", trigger: "blur" }]
      },
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      joinInfo: "loginModule/getJoinInfo",
      exhibition: "loginModule/getExhibition"
    }),
    exhibitionId() {
      return this.exhibition.id;
    }
  },
  created() {
    document.title = "中国国际医疗器械博览会 - Invoice";
    this.init();
  },
  methods: {
    ...mapActions({
      getInvoiceDown: "exhibitionModule/getInvoiceDown",
      editInvoiceDown: "exhibitionModule/editInvoiceDown",
    }),
    async init() {
      // 获取发票修改记录
      let result = await this.getInvoiceDown(this.joinInfo.joinId);
      if (result) {
        this.invoiceDownInfo = result;
        this.formInline2.Title = result.title;
        this.formInline2.Code = result.code;
        this.formInline2.BankName = result.bank;
        this.formInline2.BankNumber = result.bankAccount;
        this.formInline2.Address = result.address;
        this.formInline2.Tel = result.tel;
        // console.log("invoiceDownInfo：",this.invoiceDownInfo)
      }
    },
    async handleSubmit(name) {
      let form = this.formInline2;
      let valid = await this.validForm(name);
      if (!valid) return;

      let req = {
        Id: this.invoiceDownInfo.id,
        SetValues: {
          Title: form.Title,
          Code: form.Code,
          Address: form.Address,
          Tel: form.Tel,
          BankAccount: form.BankNumber,
          Bank: form.BankName
        }
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let result = await this.editInvoiceDown(req);
      if (result && result.successed) {
        this.$Message.success("successful");
        this.$router.push("/exhibitionEn/index/exinfo/invoice-alter");
      } else {
        this.$Message.warning(`fail,please try again`);
      }
      setTimeout(() => {
        this.loading = false;
      },1000);
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
  }
};
</script>

<style scoped lang="scss">
.invoice {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 800px;
    margin: 30px;
    padding: 40px;
    min-height: 500px;
    background: #fff;
    padding-bottom: 190px;
  }
}
</style>
